import * as types from "./mutation-types";
import * as dashboardTypes from "../dashboard/mutation-types";
import * as documentTypes from "../documentType/mutation-types";
import * as accountTypes from "../account/mutation-types";

export const fetchInvoices = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices`, { params })
      .then(response => {
        commit(types.SET_INVOICES, response.data.invoices.data);
        commit(types.SET_TOTAL_INVOICES, response.data.invoices.total);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCreateInvoice = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/create`)
      .then(response => {
        commit("documentType/" + documentTypes.ATTACHMENTS, "null", {
          root: true
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const fetchInvoice = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/${id}/edit`)
      .then(response => {
        if (response.data.invoice.delivery_note_id) {
          commit(
            types.INVOICE_HAS_DELIVERYNOTE,
            response.data.invoice.delivery_note_id
          );
          commit(types.SET_DELIVERYNOTE_ITEM, response.data.deliverynoteItems);
          commit(types.SET_INVOICE_ITEMS, response.data.invoice.items);
        }
        commit(
          types.SET_TEMPLATE_ID,
          response.data.invoice.invoice_template_id
        );
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const fetchInvoiceShow = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchDownloadInvoiceDetail = (
  { commit, dispatch, state },
  data
) => {
  console.log("data ", data);
  return new Promise((resolve, reject) => {
    window.axios
      .get(
        `/api/export/invoices-detail/customer/${data.hash}/download?from_date=${
          data.from_date
        }&to_date=${data.to_date}`
      )
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const SingleInvoiceArray = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/singleInvoiceArray/${id}`)
      .then(response => {
        if (response.data.funder_invoices) {
          commit(
            "account/" + accountTypes.SET_SELECTED_FUNDER_ACCOUNT,
            response.data.funder_invoices.user_id,
            { root: true }
          );
          commit("account/" + accountTypes.SET_SELECT_ALL_FUNDER_STATE, false, {
            root: true
          });
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const fetchViewInvoice = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendEmail = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/send`, data)
      .then(response => {
        if (response.data.success === true) {
          commit(types.UPDATE_INVOICE_STATUS, {
            id: data.invoice_id,
            status: "SENT"
          });
          commit(
            "dashboard/" + dashboardTypes.UPDATE_INVOICE_STATUS,
            { id: data.invoice_id, status: "SENT" },
            { root: true }
          );
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const unpaidCustomerInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/unpaid-customer-invoices`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const unpaidUserInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/unpaid-user-invoices`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchUserPaymentTerm = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/fetch-user-payment-term`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchPaymentApprovalDays = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices/fetch-user-payment-approval-days`, { params: { customer_id: params } })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const financedUserInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/financed-user-invoices`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const needSettlementUserInvoice = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/needsettle-user-invoices`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const needSettleCustomerInvoice = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/needsettle-customer-invoices`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addNonFinanceInvoiceInfo = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/simple-invoice-payment-info`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
// export const SentEmail = ({ commit, dispatch, state }, invoiceId) => {
//   return new Promise((resolve, reject) => {
//     window.axios.post(`/api/invoices/sent/${invoiceId}`).then((response) => {
//       resolve(response)
//     }).catch((err) => {
//       reject(err)
//     })
//   })
// }

export const addInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post("/api/invoices", data)
      .then(response => {
        commit(types.ADD_INVOICE, response.data);

        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteInvoice = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .delete(`/api/invoices/${id}`)
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          commit(types.DELETE_INVOICE, id);
          commit("dashboard/" + dashboardTypes.DELETE_INVOICE, id, {
            root: true
          });
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteMultipleInvoices = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/delete`, { ids: state.selectedInvoices })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          commit(types.DELETE_MULTIPLE_INVOICES, state.selectedInvoices);
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendMultipleInvoices = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/send-invoices`, {
        invoice_ids: state.selectedInvoices
      })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const bulkPrintInvoices = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/print`, { ids: state.selectedInvoices })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const paymentMultipleInvoices = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/make-payments`, { ids: state.selectedInvoices })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          // commit(types.DELETE_MULTIPLE_INVOICES, state.selectedInvoices)
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const bulkProcessPrePaymentInvoices = (
  { commit, dispatch, state },
  type
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/bulkProcess/pre-payment`, {
        ids: state.selectedInvoices,
        type: type
      })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const bulkProcessRequestedInvoices = (
  { commit, dispatch, state },
  id
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/bulkProcess/requested`, {
        ids: state.selectedInvoices
      })
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const bulkProcessRequestedInvoicesWithData = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/bulkProcess/requested`, data)
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const bulkApproveRequestedInvoicesWithData = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/prepaymentRequest/bulk-Prepayment-Processing`, data)
      .then(response => {
        if (response.data.error) {
          resolve(response);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .put(`/api/invoices/${data.id}`, data)
      .then(response => {
        if (response.data.invoice) {
          commit(types.UPDATE_INVOICE, response.data);
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const markAsSent = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/mark-as-sent`, data)
      .then(response => {
        commit(types.UPDATE_INVOICE_STATUS, { id: data.id, status: "SENT" });
        commit(
          "dashboard/" + dashboardTypes.UPDATE_INVOICE_STATUS,
          { id: data.id, status: "SENT" },
          { root: true }
        );
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const markAsAuthorized = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/mark-as-authorized`, data)
      .then(response => {
        commit(types.UPDATE_INVOICE_STATUS, {
          invoice_id: data.id,
          status: "AUTHORIZED"
        });
        commit(
          "dashboard/" + dashboardTypes.UPDATE_INVOICE_STATUS,
          { id: data.id, status: "AUTHORIZED" },
          { root: true }
        );
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const cloneInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/clone`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const searchInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/invoices?${data}`)
      .then(response => {
        // commit(types.UPDATE_INVOICE, response.data)
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const selectInvoice = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_INVOICES, data);
  if (state.selectedInvoices.length === state.invoices.length) {
    commit(types.SET_SELECT_ALL_STATE, true);
  } else {
    commit(types.SET_SELECT_ALL_STATE, false);
  }
};

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data);
};

export const selectAllInvoices = ({ commit, dispatch, state }) => {
  if (state.selectedInvoices.length === state.invoices.length) {
    commit(types.SET_SELECTED_INVOICES, []);
    commit(types.SET_SELECT_ALL_STATE, false);
  } else {
    let allInvoiceIds = state.invoices.map(inv => inv.id);
    commit(types.SET_SELECTED_INVOICES, allInvoiceIds);
    commit(types.SET_SELECT_ALL_STATE, true);
  }
};

export const resetSelectedInvoices = ({ commit, dispatch, state }) => {
  commit(types.RESET_SELECTED_INVOICES);
};
export const setCustomer = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_CUSTOMER);
  commit(types.SET_CUSTOMER, data);
};

export const resetCustomer = ({ commit, dispatch, state }) => {
  commit(types.RESET_CUSTOMER);
};

export const setTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_TEMPLATE_ID, data);
    resolve({});
  });
};

export const selectCustomer = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/customers/${id}`)
      .then(response => {
        commit(types.RESET_SELECTED_CUSTOMER);
        commit(types.SELECT_CUSTOMER, response.data.customer);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const resetSelectedCustomer = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_SELECTED_CUSTOMER);
};
export const FetchInvoiceSuppliers = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get("/api/invoiceSuppliers", data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const setSelectAllStateItem = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE_ITEM, data);
};
export const deleteMultipleItems = ({ commit, dispatch, state }, id) => {
  commit(types.DELETE_INVOICE_MULTIPLE_ITEMS, state.selectedInvoiceItems);
  commit(types.SET_SELECT_ALL_STATE_ITEM, false);
};
export const tempDeleteItem = ({ commit, dispatch, state }, data) => {
  commit(types.TEMP_DELETE_ITEM, data);
};
export const tempAddItem = ({ commit, dispatch, state }, data) => {
  commit(types.TEMP_ADD_ITEM, data);
};
export const selectedInvoiceItem = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_INVOICE_ITEMS, data);
  if (state.selectedInvoices.length === state.invoiceItems.length) {
    commit(types.SET_SELECT_ALL_STATE_ITEM, true);
  } else {
    commit(types.SET_SELECT_ALL_STATE_ITEM, false);
  }
};
export const addInvoiceItem = ({ commit, dispatch, state }, data) => {
  commit(types.ADD_INVOICE_ITEMS, data);
};
export const removeInvoiceItem = ({ commit, dispatch, state }, data) => {
  commit(types.DELETE_INVOICE_ITEM, data);
};
export const resetAvailableInvoiceItems = ({ commit, dispatch, state }, id) => {
  commit(types.SET_INVOICE_ITEMS, []);
};
export const resetDeliveryNoteItems = ({ commit, dispatch, state }, id) => {
  commit(types.SET_DELIVERYNOTE_ITEM, []);
};
export const importInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/importInvoice`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const rejectedInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/rejected`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const blockedInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/blocked`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const unblockedInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/invoices/unblocked`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const selectAllInvoiceItems = ({ commit, dispatch, state }) => {
  if (state.selectedInvoiceItems.length === state.invoiceItems.length) {
    commit(types.SET_SELECTED_INVOICE_ITEMS, []);
    commit(types.SET_SELECT_ALL_STATE_ITEM, false);
  } else {
    let allInvoices = state.invoiceItems.map(invoice => invoice.systemItemId);
    commit(types.SET_SELECTED_INVOICE_ITEMS, allInvoices);
    commit(types.SET_SELECT_ALL_STATE_ITEM, true);
  }
};
